import { FormControl, FormGroup } from '@angular/forms';

export const CONSTS = {
  HEADER: $localize`COD Reconcile Report`,
  FROM_LABEL: $localize`From`,
  TO_LABEL: $localize`To`,
  DATE_LABEL: $localize`Date`,
  ROUTE_LABEL: $localize`Route`,
};

export const FILE_NAME = 'COD-Reconcile-Report';

export const MOCK_RECONCILE_ROUTES = [
  {
    route: '001',
  },
  {
    route: 'PPM',
  },
];

export const MOCK_RECONCILE_REPORTS = {
  CODReconcile: [
    {
      countryCode: 'USD',
      slic: '4324',
      location: 'OHCOL',
      stopDate: '2023-11-11',
      routeId: '1',
      shipper: '2222YY',
      trackingNumber: '1Z2222YY5900068525',
      payAmount: '200.99',
      payType: 'CHEQUE',
      stopType: 'D',
    },
  ],
};

type ReconcileReportField = {
  fromDate: FormControl<Date>;
  toDate: FormControl<Date>;
  routes: FormControl<string>;
};

export type ReconcileReportFieldFormGroup =
  FormGroup<ReconcileReportField> | null;
